import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isExtending: false,
  isModifying: false,
  isCanceling: false,
  isExpiring: false,

  result: [],
};

const authExtendAndModifyReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_ALLOW_EXTEND_AND_MODIFY_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_ALLOW_EXTEND_AND_MODIFY_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_ALLOW_EXTEND_AND_MODIFY_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
    };

  case types.POST_EXTEND_AUTH_REQUEST:
    return {
      ...state,
      result: [],
      isExtending: true,
    };

  case types.POST_EXTEND_AUTH_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isExtending: false,
    };

  case types.POST_EXTEND_AUTH_FAILURE:
    return {
      ...state,
      result: [],
      isExtending: false,
    };

  case types.POST_MODIFY_AUTH_REQUEST:
    return {
      ...state,
      result: [],
      isModifying: true,
    };

  case types.POST_MODIFY_AUTH_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isModifying: false,
    };

  case types.POST_MODIFY_AUTH_FAILURE:
    return {
      ...state,
      result: [],
      isModifying: false,
    };

  case types.POST_CANCEL_AUTH_REQUEST:
    return {
      ...state,
      result: [],
      isCanceling: true,
    };

  case types.POST_CANCEL_AUTH_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isCanceling: false,
    };

  case types.POST_CANCEL_AUTH_FAILURE:
    return {
      ...state,
      result: [],
      isCanceling: false,
      };

  case types.POST_EXPIRE_AUTH_REQUEST:
    return {
      ...state,
      result: [],
      isExpiring: true,
    };

  case types.POST_EXPIRE_AUTH_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isExpiring: false,
    };

  case types.POST_EXPIRE_AUTH_FAILURE:
    return {
      ...state,
      result: [],
      isExpiring: false,
    };

  default:
    return state;
  }
};

export default authExtendAndModifyReducer;
